import { styled, secondaryFontFamily } from '@openeducation/oe-it-themes';
import { LinearGradient } from 'expo-linear-gradient';
import { lighten } from 'polished';
import React, { ReactNode } from 'react';
import type { StyleProp, ViewStyle, TextStyle } from 'react-native';
import { View } from 'react-native';
import { useTheme } from 'react-native-paper';

import { OEButton, OEText } from '../../atoms';
import { width, flex } from '../../style-utils';

export interface SloganBannerProps {
  text?: string;
  children?: ReactNode;
  gradientColors?: string[];
  button?: {
    text: string;
    onPress: () => void;
    color?: string;
    style?: StyleProp<ViewStyle>;
    labelStyle?: StyleProp<TextStyle>;
  };
  textStyle?: StyleProp<TextStyle>;
  wrapperWidth?: number | string;
  style?: StyleProp<ViewStyle>;
}

export const SloganBanner = ({
  button,
  gradientColors,
  style,
  textStyle,
  wrapperWidth = '100%',
  children,
  text,
}: SloganBannerProps) => {
  const theme = useTheme();
  const colors = gradientColors || [
    lighten(0.15, theme.colors.primary),
    theme.colors.primary,
  ];

  return (
    <Container colors={colors} style={style}>
      <Wrapper style={width(wrapperWidth)}>
        {text && <Slogan style={textStyle}>{text}</Slogan>}
        {children && (
          <View style={[flex('flex-1', 'flex-row')]}>{children}</View>
        )}
        {button && (
          <Button
            onPress={button.onPress}
            style={button?.style}
            color={button?.color}
            labelStyle={button?.labelStyle}
          >
            {button.text}
          </Button>
        )}
      </Wrapper>
    </Container>
  );
};

const Container = styled(LinearGradient)`
  border-radius: 14px;
  align-items: center;
  padding: 27px 30px;
`;
const Wrapper = styled.View`
  flex-direction: row;
  align-items: center;
`;

const Slogan = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.white,
  fontFamily: secondaryFontFamily,
  fontStyle: 'semiBold',
  fontSize: 20,
}))`
  flex: 1;
`;

const Button = styled(OEButton).attrs(({ theme, color }) => ({
  color: color || theme.color.accent,
  size: 'large',
}))``;

export default SloganBanner;
